import { CountFrequency } from '../FinancialForensics.types';
import { StopLossVendor } from './StopLoss.types';
import { Detail } from './VariableCost.types';

export type FixedCostFeeOption = 'Enter Breakdown' | 'Enter Total Fee';

export interface FeeCalculation {
  source: string;
  detailsType: CountFrequency | undefined;
  details: Detail[];
}

export interface FixedCostFeeCalculation extends FeeCalculation {
  option?: FixedCostFeeOption;
}

interface BaseService {
  serviceID: string;
  startDate: string;
  endDate: string;
  nameOfService: string;
  unitOfFees: string;
  value: string;
  fees: number;
  feeCalculation: FixedCostFeeCalculation;
  isChosen: boolean;
  capFee: number;
  flatFee: number;
}

export interface FeeService extends BaseService {
  payer: string;
  modeOfPayment: string;
  applicable: string;
}

export interface OpportunityService extends BaseService {
  receiver: string;
}

export type Service = FeeService & OpportunityService;

export interface Vendor {
  vendorID: string;
  nameOfVendor: string;
  services: Service[];
}

export interface FixedCostPlanContribution {
  fees: Vendor[];
  credits: Vendor[];
  stoploss: StopLossVendor[];
}

export interface FixedCost {
  planContribution: FixedCostPlanContribution;
  memberContribution: Vendor[];
}

export interface Document {
  _id: string;
  eg_nid: string;
  startDate: string;
  endDate: string;
  status: string;
  usedFor: string;
  fileName: string;
  fileUrl: string;
  fileType: string;
  fileSize: number;
  isDeleted: boolean;
  uploadedBy: string;
  uploadedAt: string;
}

export const emptyFixedCostFeeCalculation = (): FixedCostFeeCalculation => ({
  source: '',
  option: undefined,
  detailsType: undefined,
  details: [],
});

export const emptyService = (
  startDate?: string,
  endDate?: string,
): Service => ({
  serviceID: '',
  startDate: startDate ?? '',
  endDate: endDate ?? '',
  nameOfService: '',
  unitOfFees: '',
  value: '',
  fees: 0,
  feeCalculation: emptyFixedCostFeeCalculation(),
  isChosen: false,
  capFee: 0,
  flatFee: 0,
  payer: '',
  modeOfPayment: '',
  applicable: '',
  receiver: '',
});

export const emptyVendor = (startDate?: string, endDate?: string): Vendor => ({
  vendorID: '',
  nameOfVendor: '',
  services: [emptyService(startDate, endDate)],
});

export const getEmptyFixedCost = (): FixedCost => ({
  planContribution: {
    fees: [],
    credits: [],
    stoploss: [],
  },
  memberContribution: [],
});
